export default {
  allAssets: 'Všetky zariadenia',
  zeroAssets: 'Vybraných je 0 zariadení',
  assets: 'zariadenia',
};
